import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  static targets = ["list", "status", "reload"]
  static values = { url: String }

  connect() {
    this.savedOrder = this.order()
    this.saving = false
    this.sortable = Sortable.create(this.listTarget, {
      animation: 180,
      handle: ".sort-handle",
      draggable: "[data-sort-id]",
      ghostClass: "course-sort-ghost",
      chosenClass: "course-sort-chosen",
      onEnd: () => this.save()
    })
  }

  disconnect() {
    this.sortable?.destroy()
  }

  move(event) {
    if (this.saving) return

    const row = event.currentTarget.closest("[data-sort-id]")
    const direction = event.currentTarget.dataset.direction
    const neighbor = direction === "up" ? row.previousElementSibling : row.nextElementSibling
    if (!neighbor) return

    if (direction === "up") {
      this.listTarget.insertBefore(row, neighbor)
    } else {
      this.listTarget.insertBefore(neighbor, row)
    }
    this.save()
  }

  reload() {
    window.location.reload()
  }

  order() {
    return Array.from(this.listTarget.querySelectorAll(":scope > [data-sort-id]"), row => row.dataset.sortId)
  }

  async save() {
    const ids = this.order()
    if (this.saving || ids.every((id, index) => id === this.savedOrder[index])) return

    this.saving = true
    this.sortable.option("disabled", true)
    this.listTarget.querySelectorAll("button").forEach(button => { button.disabled = true })
    this.statusTarget.textContent = "Сохраняем порядок…"
    this.reloadTarget.hidden = true

    try {
      const response = await fetch(this.urlValue, {
        method: "PATCH",
        credentials: "same-origin",
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
        },
        body: JSON.stringify({ ids, expected_ids: this.savedOrder })
      })
      if (!response.ok) throw new Error("Порядок не сохранён. Обновите страницу и попробуйте снова.")

      this.savedOrder = ids
      this.statusTarget.textContent = "Порядок сохранён"
    } catch (error) {
      const rows = new Map(Array.from(this.listTarget.children, row => [row.dataset.sortId, row]))
      this.savedOrder.forEach(id => {
        if (rows.has(id)) this.listTarget.appendChild(rows.get(id))
      })
      this.statusTarget.textContent = error.message
      this.reloadTarget.hidden = false
    } finally {
      this.saving = false
      this.sortable.option("disabled", false)
      this.listTarget.querySelectorAll("button").forEach(button => { button.disabled = false })
    }
  }
}
